// Icône de chaque moyen de règlement déclaré par un donateur (mêmes codes
// que lib/relances.js → METHODES_DECLARATION). Partagé par la page publique
// de paiement et les écrans du responsable.
import { Banknote, PenLine, Landmark, MoreHorizontal } from "lucide-react";

export const ICONES_METHODES = {
  especes: Banknote,
  cheque: PenLine,
  virement: Landmark,
  autre: MoreHorizontal,
};

export const iconeMethode = (code) => ICONES_METHODES[code] || MoreHorizontal;
